/* Charliee card behaviour: image carousel dots, wishlist, add-to-cart stepper. */
(function () {
  'use strict';

  var cartMap = {};
  var WISH_KEY = 'chl_wishlist';

  /* ---------------- cart ---------------- */
  function loadCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        cartMap = {};
        (cart.items || []).forEach(function (i) {
          cartMap[String(i.variant_id)] = { qty: i.quantity, key: i.key };
        });
        return cartMap;
      })
      .catch(function () { return (cartMap = {}); });
  }

  function refreshBubble() {
    fetch('/?section_id=cart-icon-bubble')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('.cart-count-bubble');
        document.querySelectorAll('#cart-icon-bubble, .header__icon--cart').forEach(function (n) {
          var old = n.querySelector('.cart-count-bubble');
          if (old) old.remove();
          if (fresh) n.appendChild(fresh.cloneNode(true));
        });
      })
      .catch(function () {});
  }

  function post(url, payload) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (r) { return r.json(); });
  }

  /* ---------------- stepper ---------------- */
  function renderStepper(actions, variantId, addBtn) {
    var entry = cartMap[String(variantId)];
    if (!entry) return;

    var wrap = document.createElement('div');
    wrap.className = 'chl-stepper';

    var minus = document.createElement('button');
    minus.type = 'button';
    minus.setAttribute('aria-label', 'Decrease quantity');
    minus.textContent = '\u2212';

    var qty = document.createElement('span');
    qty.className = 'chl-qty';
    qty.textContent = entry.qty;

    var plus = document.createElement('button');
    plus.type = 'button';
    plus.setAttribute('aria-label', 'Increase quantity');
    plus.textContent = '+';

    function set(next) {
      wrap.classList.add('is-busy');
      post('/cart/change.js', { id: entry.key, quantity: next })
        .then(loadCart)
        .then(function () {
          refreshBubble();
          var updated = cartMap[String(variantId)];
          if (!updated) {
            wrap.remove();
            addBtn.hidden = false;
            addBtn.removeAttribute('aria-busy');
          } else {
            entry.qty = updated.qty;
            entry.key = updated.key;
            qty.textContent = updated.qty;
            wrap.classList.remove('is-busy');
          }
        })
        .catch(function () { wrap.classList.remove('is-busy'); });
    }

    minus.addEventListener('click', function () { set(Math.max(0, entry.qty - 1)); });
    plus.addEventListener('click', function () { set(entry.qty + 1); });

    wrap.appendChild(minus);
    wrap.appendChild(qty);
    wrap.appendChild(plus);

    addBtn.hidden = true;
    actions.insertBefore(wrap, addBtn);
  }

  function bindAdd(btn) {
    if (btn.dataset.chlBound === '1') return;
    btn.dataset.chlBound = '1';

    var variantId = btn.getAttribute('data-variant');
    var actions = btn.closest('[data-chl-actions]') || btn.parentElement;
    if (!variantId || !actions) return;

    if (cartMap[String(variantId)]) renderStepper(actions, variantId, btn);

    btn.addEventListener('click', function () {
      btn.setAttribute('aria-busy', 'true');
      post('/cart/add.js', { items: [{ id: Number(variantId), quantity: 1 }] })
        .then(loadCart)
        .then(function () {
          refreshBubble();
          btn.removeAttribute('aria-busy');
          if (cartMap[String(variantId)]) renderStepper(actions, variantId, btn);
        })
        .catch(function () { btn.removeAttribute('aria-busy'); });
    });
  }

  /* ---------------- carousel dots ---------------- */
  function bindCarousel(car) {
    if (car.dataset.chlBound === '1') return;
    car.dataset.chlBound = '1';

    var media = car.closest('.chl-card__media');
    if (!media) return;
    var dots = media.querySelector('[data-chl-dots]');
    if (!dots) return;
    var marks = dots.querySelectorAll('.chl-dot');
    if (!marks.length) return;

    var ticking = false;
    car.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        var index = Math.round(car.scrollLeft / Math.max(1, car.clientWidth));
        if (index < 0) index = 0;
        if (index > marks.length - 1) index = marks.length - 1;
        marks.forEach(function (m, i) { m.classList.toggle('is-active', i === index); });
        ticking = false;
      });
    }, { passive: true });
  }

  /* ---------------- wishlist ---------------- */
  function readWish() {
    try { return JSON.parse(localStorage.getItem(WISH_KEY) || '[]'); } catch (e) { return []; }
  }
  function writeWish(list) {
    try { localStorage.setItem(WISH_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function bindWish(btn) {
    if (btn.dataset.chlBound === '1') return;
    btn.dataset.chlBound = '1';

    var card = btn.closest('[data-chl-card]');
    var link = card && card.querySelector('.chl-title');
    var id = link ? link.getAttribute('href') : null;
    if (!id) return;

    if (readWish().indexOf(id) !== -1) btn.classList.add('is-on');

    btn.addEventListener('click', function () {
      var list = readWish();
      var at = list.indexOf(id);
      if (at === -1) { list.push(id); btn.classList.add('is-on'); }
      else { list.splice(at, 1); btn.classList.remove('is-on'); }
      writeWish(list);
    });
  }

  /* ---------------- boot ---------------- */
  function scan() {
    document.querySelectorAll('[data-chl-add]').forEach(bindAdd);
    document.querySelectorAll('[data-chl-carousel]').forEach(bindCarousel);
    document.querySelectorAll('[data-chl-wish]').forEach(bindWish);
  }

  function init() { loadCart().then(scan); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', init);
})();
